export default "__VITE_ASSET__348EwLNZ__"